// extracted by mini-css-extract-plugin
module.exports = {"vehicleMassLoad":"styles_vehicleMassLoad__Frp-F","vehiclesForSales":"styles_vehiclesForSales__1p1mt","vehicleMassLoadBackButtom":"styles_vehicleMassLoadBackButtom__3Ro5z"};